export const common = {
  appName: 'NT Academy',
  yes: 'Sim',
  no: 'Não',
  save: 'Salvar',
  cancel: 'Cancelar',
  loading: 'Carregando...',
  search: 'Buscar',
  searchPlaceholder: 'Digite para buscar...',
  name: 'Nome',
  status: 'Status',
  updatedAt: 'Atualizado em',
  optional: 'Opcional',
  statuses: {
    active: 'Ativo',
    inactive: 'Inativo',
    draft: 'Rascunho',
    published: 'Publicado',
    archived: 'Arquivado',
  },
  roles: {
    aluno: 'Aluno',
    professor: 'Professor',
    curador: 'Curador',
    admin: 'Admin',
  },
  prazo: {
    atrasado: 'Atrasado',
    em_risco: 'Em risco',
    no_prazo: 'No prazo',
  },
  tipo: {
    curso: 'Curso',
    trilha: 'Trilha',
  },
  actions: {
    back: 'Voltar',
    retry: 'Tentar de novo',
    confirm: 'Confirmar',
    close: 'Fechar',
    continue: 'Continuar',
    edit: 'Editar',
    delete: 'Excluir',
    remove: 'Remover',
    create: 'Criar',
    add: 'Adicionar',
    publish: 'Publicar',
    archive: 'Arquivar',
  },
  errors: {
    required: 'Campo obrigatório',
    invalidEmail: 'E-mail inválido',
    network: 'Falha de conexão. Tente novamente.',
    generic: 'Algo deu errado. Tente novamente.',
  },
  nav: {
    sidebar: 'Barra lateral',
    inicio: 'Início',
    catalogo: 'Catálogo',
    meusCertificados: 'Meus certificados',
    autoria: 'Autoria',
    curadoria: 'Curadoria',
    painelProfessor: 'Painel do professor',
    painelCurador: 'Painel do curador',
    visaoGlobal: 'Visão global',
    usuarios: 'Usuários',
    language: 'Idioma',
    theme: 'Tema',
    userMenu: 'Menu do usuário',
  },
  themes: {
    light: 'Claro',
    dark: 'Escuro',
    system: 'Sistema',
  },
  notFound: {
    title: 'Página não encontrada',
    description: 'A página que você procura não existe ou foi movida.',
    back: 'Voltar para a página inicial',
  },
  errorBoundary: {
    title: 'Algo deu errado',
    description: 'Ocorreu um erro inesperado. Recarregue a página e tente novamente.',
    reload: 'Recarregar',
  },
  lesson: {
    videoUrlPlaceholder: 'Cole a URL do YouTube ou Vimeo',
    videoUrlLabel: 'URL do vídeo',
    videoInsert: 'Inserir',
    videoUnsupported: 'Provedor não suportado. Use YouTube ou Vimeo.',
  },
} as const;
